//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MoneyIntentionDetail',
  data() {
    return {
      applyInfo: [], // 申请信息
      detailList: {}, // 详情列表
      loanSubsidyLimitNum: '', // 年利率
      businessOutlets: '', // 业务网点
      region: '', // 地区
    }
  },
  created() {
    this.businessOutlets = this.$route.query.businessOutlets
    this.region = this.$route.query.region
    this.getLoanIntentionSelectOneList()
  },
  methods: {
    getLoanIntentionSelectOneList() {
      let params = {
        id: this.$route.query.id,
      }
      this.$http.bank.getLoanIntentionSelectOneList(params).then((res) => {
        let _res = res.data
        this.applyInfo.push({
          createTime: _res.createTime,
          personName: _res.personName,
          mobile: _res.mobile,
          region: this.region,
        })
        this.detailList = res.data
        let num = res.data.maxYearRate / res.data.minYearRate
        this.loanSubsidyLimitNum = Math.round(num * 100) / 100
      })
    },
  },
}
